import { useState } from 'react';
import Nav from '../sections/Nav';
import DigitalMaterialPassport from '../sections/DigitalMaterialPassport';
import Footer from '../sections/Footer';
import ContactForm from '../ContactForm';
import { useSEO } from '../useSEO';

const DigitalMaterialPassportPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [contactFormMode, setContactFormMode] = useState('contact');

  useSEO({
    title: 'Digital Material Passport | Nthra Labs',
    description: 'From requirement to proof in four steps — onboarding, digital specification, digital negotiation, and continuous conformance, issuing a signed Material Conformance Certificate for every shipment.',
    path: '/digital-material-passport',
  });

  const openContactForm = (mode) => {
    setContactFormMode(mode);
    setIsContactFormOpen(true);
  };

  return (
    <div style={{ fontFamily: "'DM Sans',sans-serif", background: '#ffffff', color: '#1a1a1a', minHeight: '100vh' }}>
      <Nav onOpenContact={openContactForm} />
      <h1 className="sr-only">Digital Material Passport</h1>
      <div style={{ paddingTop: 24 }} />
      <DigitalMaterialPassport />
      <Footer />
      <ContactForm
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        mode={contactFormMode}
      />
    </div>
  );
};

export default DigitalMaterialPassportPage;
